import React from "react";
import { ThemePaletteState, ThemePalette, ThemeShadowSizes } from "../../../theme/_Types";
import { Div } from "../03-base/Div";
import { Navbar } from "./Navbar";
import { NavbarStack, NavbarStackContent, NavbarStackRight } from "./Navbar/Stack";
import { NavbarTitle } from "./Navbar/Title";
import { Button } from "../05-atoms/Button";
import * as I18n from "../../../utils/translations/I18n";
import { BreakpointConsumer } from "../../../utils/Breakpoints";
import { NavLink } from "react-router-dom";
export var FormBarSize;
(function (FormBarSize) {
    FormBarSize["FULL_WIDTH"] = "FULL_WIDTH";
    FormBarSize["WITH_SIDEBAR"] = "WITH_SIDEBAR";
    FormBarSize["WITH_COLLAPSED_SIDEBAR"] = "WITH_COLLAPSED_SIDEBAR";
})(FormBarSize || (FormBarSize = {}));
export var navbarTheme = function (isValid) {
    if (isValid === true) {
        return { paletteState: ThemePaletteState.SUCCESS };
    }
    else if (isValid === false) {
        return { paletteState: ThemePaletteState.DANGER };
    }
    return { palette: ThemePalette.BRAND_ACCENT };
};
export var FormBar = function (props) { return (React.createElement(BreakpointConsumer, null, function (value) { return (React.createElement(Div, { className: "scl-o-formbar ".concat(props.size === FormBarSize.WITH_COLLAPSED_SIDEBAR
        ? "scl-o-formbar--collapsed-sidebar"
        : props.size === FormBarSize.FULL_WIDTH ? "scl-o-formbar--no-sidebar" : ""), theme: {
        shadow: ThemeShadowSizes.HUGE,
    } },
    React.createElement(Navbar, { theme: navbarTheme(props.isValid), className: "scl-h-text-align--left" },
        React.createElement(NavbarStack, null,
            value.breakpointAtSM &&
                React.createElement(NavbarStackContent, null,
                    React.createElement(NavbarTitle, null, props.title)),
            React.createElement(NavbarStackRight, null,
                React.createElement(Div, { theme: { padding: { "": { x: 2 }, "sm": { x: 3 } } } },
                    React.createElement(Div, { style: {
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                        } },
                        (!!props.isValid || !!props.showButton) &&
                            React.createElement(Div, { theme: { padding: { "": { l: 2 }, "sm": { l: 3 } } } }, !!props.onClick || !!props.navLink ?
                                !!props.navLink ?
                                    React.createElement(NavLink, { to: props.navLink },
                                        React.createElement(Button, { className: "scl-a-btn--big", style: { marginRight: "10px" }, theme: { palette: ThemePalette.CONTRAST_PRIMARY } }, props.buttonLabel ? props.buttonLabel : "Continue"))
                                    :
                                        React.createElement(Button, { link: {
                                                onClick: function () {
                                                    return props.onClick ? props.onClick() : null;
                                                },
                                            }, className: "scl-a-btn--big", style: { marginRight: "10px" }, theme: { palette: ThemePalette.CONTRAST_PRIMARY } }, props.buttonLabel ? props.buttonLabel : "Continue") :
                                React.createElement(Button, { buttonType: "submit", className: "scl-a-btn--big", style: { marginRight: "10px" }, theme: { palette: ThemePalette.CONTRAST_PRIMARY } }, props.buttonLabel ? props.buttonLabel : "Continue")),
                        (props.hasRequiredFields && props.isValid !== true) ? (React.createElement(Div, { theme: { padding: { "": { l: 2 }, "sm": { l: 3 } } } },
                            React.createElement("b", null, I18n.getText("mary.07-organisms.formbar.required", "Make sure all mandatory fields are filled in.")))) :
                            (!!props.invalidMessage && props.isValid !== true) && (React.createElement(Div, { theme: { padding: { "": { l: 2 }, "sm": { l: 3 } } } },
                                React.createElement("b", null, props.invalidMessage)))))))))); })); };
